import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { IGetBusinessPossibleAppointmentsResponse } from '../../repositories/announcements/v1/get-business-possible-appointments';

export const SET_BUSINESS_APPOINTMENTS_TYPE = 'businessAppointments/set_business_appointments_type' as const;

export type TSetBusinessAppointments = IReduxAction<
  typeof SET_BUSINESS_APPOINTMENTS_TYPE,
  IGetBusinessPossibleAppointmentsResponse | null
>;

export const setBusinessAppointmentsAction = actionGenerator<
  typeof SET_BUSINESS_APPOINTMENTS_TYPE,
  IGetBusinessPossibleAppointmentsResponse | null
>(SET_BUSINESS_APPOINTMENTS_TYPE);
